import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const pxToRem = (px: number): string => `${px / 16}rem`;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: `${pxToRem(48)} ${pxToRem(140)} ${pxToRem(140)} ${pxToRem(140)}`,
  },
  title: {
    textAlign: 'center',
  },
}));

export default useStyles;
